// 사업분야
export const projectTypeItems = [
  { value: "city", name: "도시의개발" },
  { value: "building", name: "건축물" },
  { value: "energy", name: "에너지" },
  { value: "waste", name: "폐기물처리시설" },
  { value: "excreta", name: "분뇨처리시설" },
  { value: "livestock_excreta", name: "가축분뇨처리시설" },
];

// 진행상태
export const projectStateItems = [
  { value: "registered", name: "접수", className: "text-[17px] text-[#03983C] font-medium" },
  { value: "progress", name: "진행", className: "text-[17px] text-[#03983C] font-medium" },
  { value: "complete", name: "완료", className: "text-[17px] text-[#009bfa] font-medium" },
  { value: "correction", name: "보완", className: "text-[17px] text-[#009bfa] font-medium" },
  { value: "refuse", name: "반려", className: "text-[17px] text-[#eb6100] font-medium" },
  { value: "agreement", name: "협의", className: "text-[17px] text-[#eb6100] font-medium" },
];

// 진행단계
export const projectStepItems = [
  { value: "preparation_form", name: "평가준비서", className: "text-[17px] text-gg-blue font-medium" },
  { value: "draft", name: "초안", className: "text-[17px] text-gg-blue font-medium" },
  { value: "main_proposal", name: "본안", className: "text-[17px] text-gg-blue font-medium" },
  {
    value: "environmental_impact_document",
    name: "사후환경영향조사",
    className: "text-[17px] text-gg-blue font-medium",
  },
  { value: "re_agreement", name: "재협의", className: "text-[17px] text-gg-blue font-medium" },
  { value: "change_agreement", name: "변경 협의", className: "text-[17px] text-gg-blue font-medium" },
];
